//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const RequireModeLogin: FeatureFlag = {"Id":"RequireModeLogin","Label":"Require login type to match mode default","Impact":"Users are prompted to re-login when access part of the site that required a higher mode of login. I.E. logging in as visitor and then going to the admin, or logging in as adminstor and then going to a staff page","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":3};
